// extracted by mini-css-extract-plugin
export var instagramLink = "InstagramLink-module--instagram-link--xa0R9";
export var instagramLogo = "InstagramLink-module--instagram-logo--BoOhr";
export var instagramHandle = "InstagramLink-module--instagram-handle--1YCav";